import { CopyButton } from '@/_components/ui/copy-button'
import { TableCell } from '@/_components/ui/table'
import type { RowConfig } from '../_helpers/field-config'
import { formatRowValueForDisplay } from '../_helpers/formatting'

interface OfficialValueCellProps {
  row: RowConfig
  officialValue: string | null
}

export const OfficialValueCell = ({ row, officialValue }: OfficialValueCellProps) => {
  const display = officialValue ? formatRowValueForDisplay(row, officialValue) : null

  return (
    <TableCell className="group relative border-l border-brand-grayscale-4 px-4 py-3 align-top">
      <div className="flex min-h-[1.5rem] items-center pr-7 text-[13px] tabular-nums">
        {display && <span className="text-brand-grayscale-7">{display}</span>}
      </div>
      {display && (
        <CopyButton
          value={display}
          className="absolute right-2 top-2 opacity-0 transition-opacity duration-150 group-hover:opacity-100 focus-visible:opacity-100"
        />
      )}
    </TableCell>
  )
}
